<div id="page-not-found">
    <div class="main-container">
        <h1>404</h1>
        <h2>Page not Found</h2>
    </div>
</div>